import React from "react";
import dayjs from "dayjs";
import CustomTags from "../../../Core/Components/CustomTags";
import { RENTAL_STATUS } from "../../Rentals/constant";

export const getRentalStatusBadge = (status) => {
  const numStatus = Number(status);
  switch (numStatus) {
    case RENTAL_STATUS.ONGOING: // 1
      return (
        <CustomTags colors="tripOngoing" background="tripOngoing">
          <div className="flex items-center gap-x-2">Ongoing</div>
        </CustomTags>
      );
    case RENTAL_STATUS.APPROVED: // 5
      return (
        <CustomTags colors="checkIn" background="checkIn">
          <div className="flex items-center gap-x-2">Upcoming</div>
        </CustomTags>
      );
    case RENTAL_STATUS.COMPLETED: // 2
      return (
        <CustomTags colors="tripCompleted" background="tripCompleted">
          <div className="flex items-center gap-x-2">Completed</div>
        </CustomTags>
      );
    default:
      return (
        <CustomTags colors="tripOngoing" background="tripOngoing">
          <div className="flex items-center gap-x-2">Ongoing</div>
        </CustomTags>
      );
  }
};

export const rentalTrikeColumns = [
  {
    title: () => (
      <div className="font-light font-aileron text-10 text-dark-gray">
        Rental ID
      </div>
    ),
    dataIndex: "id",
    sorter: (a, b) => (Number(a?.id) || 0) - (Number(b?.id) || 0),
    render: (text) => (
      <div className="text-xs font-semibold text-black font-aileron">
        {text}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-light font-aileron text-10 text-dark-gray">
        Driver
      </div>
    ),
    dataIndex: "driver",
    sorter: (a, b) => {
      const nameA = a?.firstName ? `${a.firstName} ${a.lastName}` : (a?.driverName || "");
      const nameB = b?.firstName ? `${b.firstName} ${b.lastName}` : (b?.driverName || "");
      return nameA.localeCompare(nameB);
    },
    render: (text, record) => {
      const name = record?.firstName
        ? `${record.firstName} ${record.lastName}`
        : record?.driverName || "--";
      return (
        <div className="text-xs font-semibold capitalize font-aileron text-dark-gray">
          {name}
        </div>
      );
    },
  },
  {
    title: () => (
      <div className="font-light font-aileron text-10 text-dark-gray">Date</div>
    ),
    dataIndex: "startDate",
    sorter: (a, b) => {
      const dateA = a?.startTime || a?.submittedAt || a?.pickupDate || "";
      const dateB = b?.startTime || b?.submittedAt || b?.pickupDate || "";
      return String(dateA).localeCompare(String(dateB));
    },
    render: (text, record) => {
      const dateVal = record?.startTime || record?.submittedAt || record?.pickupDate;
      return (
        <div className="text-xs font-semibold capitalize font-aileron text-dark-gray">
          {dateVal ? dayjs(dateVal).format("ddd, MMM DD YYYY") : "--"}
        </div>
      );
    },
  },
  {
    title: () => (
      <div className="font-light font-aileron text-10 text-dark-gray">
        Start Time
      </div>
    ),
    dataIndex: "startTime",
    sorter: (a, b) => {
      const timeA = a?.startTime || a?.pickupTime || "";
      const timeB = b?.startTime || b?.pickupTime || "";
      return String(timeA).localeCompare(String(timeB));
    },
    render: (text, record) => {
      let formattedTime = "--";
      if (record?.startTime) {
        formattedTime = dayjs(record.startTime).format("hh:mm A");
      } else if (record?.pickupTime) {
        formattedTime = dayjs(record.pickupTime, "HH:mm:ss").format("hh:mm A");
      } else if (record?.submittedAt) {
        formattedTime = dayjs(record.submittedAt).format("hh:mm A");
      }
      return (
        <div className="text-xs font-semibold capitalize font-aileron text-dark-gray">
          {formattedTime}
        </div>
      );
    },
  },
  {
    title: () => (
      <div className="font-light font-aileron text-10 text-dark-gray">
        Status
      </div>
    ),
    dataIndex: "status",
    sorter: (a, b) => Number(a?.status || 0) - Number(b?.status || 0),
    render: (text, record) => (
      <div className="flex items-center gap-x-4">
        <div className="text-xs font-medium font-aileron leading-4.5 uppercase text-dark-gray">
          {getRentalStatusBadge(record?.status)}
        </div>
      </div>
    ),
  },
];
